export function abbreviateAmsCustomerName(customerName: string) {
    switch (customerName) {
        case "Acuity A Mutual Insurance Company":
            return "Acuity";
        case "Great West Casualty Company":
            return "Great West";
        case "National Interstate":
        case "National Interstate Ins Co of Hawaii":
        case "National Interstate Ins. Co":
            return "NII";
        case "Hartford Insurance Group":
            return "Hartford";
        case "Travelers Insurance Company":
            return "Travelers";
        case "JM Wilson Corporation":
            return "JM Wilson";
        case "AmWins Brokerage of the Midwest, LLC":
            return "AMWins";
        case "Central Mutual Insurance Company":
            return "Central";
        case "Progressive Insurance":
            return "Progressive";
        case "Sunforest Transportation Insurance Group Inc.":
            return "Sunforest";
        case "Great Lakes General Agency":
            return "GLGA";
        case "Northland Insurance Company":
            return "Northland";
        case "Great American Insurance Company":
            return "Great American";
        case "Carolina Casualty Insurance Company":
            return "Carolina Casualty";
        default:
            return customerName;
    }
}